//React
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route, Switch} from "react-router-dom";

//CSS
import './assets/css/index.css'
import 'antd/dist/antd.css';
import 'semantic-ui-css/semantic.min.css'

//Components
import Home from "./pages/Home"
import MyFooter from "./components/Utils/MyFooter";
import MyNav from "./components/Utils/MyNav";
import {BackTop} from "antd";

ReactDOM.render(
        <BrowserRouter>
            <MyNav/>
            <div className="gqlx-content">
                <BackTop/>
                <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>
                </Switch>
            </div>
            <MyFooter/>
        </BrowserRouter>,
    document.getElementById('root')
);